define([
	"csi/service/fontService",
	"./_TextStyle",
	"./PluginFactory"
], function(fontService, _TextStyle, PluginFactory) {

	return PluginFactory.declare(_TextStyle, {
		"class": "csi-button-toggle csi-toggle-group-first",
		cssValue: "font-weight",
		materialIcon: "format_bold",
		pluginName: "strong",
		title: "CanvasBold",
		isBold: false,

		/**
		 * Update plugin value and disabled status based on selected shapes and attributes
		 * @param  {Shape[]} shapes
		 * @param  {Object} shapeAttrs
		 * @param  {Object} textAttrs
		 * @return {Boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			const { cssValue, editor } = this;
			if (shapes && shapes.length && editor.isSelectCanvasMode()) {
				this.isBold = parseInt(editor.canvasApp.selection.getCommonTextValue(shapes, cssValue, true) || "0") >= 500;
			} else if (editor.isEditTextCanvasMode()) {
				this.isBold = parseInt(fontService.getFroalaSelectionSpanStyle(cssValue) || "0") >= 500;
			}
			this.set("checked", this.isBold, false);
			return true;
		},

		/**
		 * Apply style
		 * @param  {Event} e
		 */
		onClick: function(e) {
			const { checked, cssValue, editor, isBold } = this;
			const weight = isBold ? "400" : "700";
			editor.setTextStyle(cssValue, weight, checked);

			// rerun enablePlugin to re-evaluate fontWeight dropDown value
			editor._plugins.fontWeight.enablePlugin();
		}
	});
});
